import { Resources } from 'constants/resources';

import { RecordContextProvider, useGetOne } from 'react-admin';
import { Box } from 'shared/mui/Box';
import { CardHeader } from 'shared/mui/Card/CardHeader/CardHeader';
import { Dialog, DialogProps } from 'shared/mui/Dialogs';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { WorkTeamsShowDialogSkeleton } from 'shared/widgets/WorkTeamsShowDialog/WorkTeamsShowDialogSkeleton';
import { WorkTeamsShowTable } from 'shared/widgets/WorkTeamsShowTable/WorkTeamsShowTable';
import { WorkTeam } from 'types/embedded/workTeam';

import { StyledBox } from './WorkTeamsShowDialog.styled';

export type WorkTeamsShowDialogProps = {
  workTeam?: Partial<WorkTeam>;
  onClose: () => void;
} & DialogProps;

export const WorkTeamsShowDialog = ({ open, workTeam, onClose }: WorkTeamsShowDialogProps) => {
  const { data, isLoading } = useGetOne(
    Resources.WorkTeams,
    { id: workTeam?.['@id'] },
    { enabled: !!workTeam?.['@id'] },
  );

  return (
    <Dialog onClose={onClose} open={open} width="640px">
      <StyledBox>
        <CardHeader
          appendActions={[<CloseIconButton key="close-button" onClose={onClose} />]}
          title="Рабочая группа"
          titleSize="smallBold"
        />
        <Box sx={{ padding: '24px' }}>
          {!isLoading ? (
            <RecordContextProvider value={data}>
              <WorkTeamsShowTable />
            </RecordContextProvider>
          ) : (
            <WorkTeamsShowDialogSkeleton />
          )}
        </Box>
      </StyledBox>
    </Dialog>
  );
};
